// Small wording helpers shared by the customer list, panel and call sheet.

export const plural = (value, one, many = `${one}s`) => (Number(value) === 1 ? one : many);

export function cadence(days) {
  const value = Number(days);
  if (!value) return "";
  if (value <= 1) return "daily";
  if (value === 7) return "weekly";
  if (value % 7 === 0) return `every ${value / 7} weeks`;
  return `every ${value} days`;
}

export function daysAgo(days) {
  if (days == null) return "";
  const value = Number(days);
  if (value <= 0) return "today";
  if (value === 1) return "yesterday";
  return `${value} days ago`;
}

export function phoneText(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return local.length === 10 ? `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}` : String(phone || "");
}

export const STATUS_TONES = {
  late: "late", switching: "elsewhere", spending_less: "less", ordering_less: "quiet", smaller_orders: "quiet",
};

const REASON_TITLES = {
  late: "Stopped ordering", switching: "Buying elsewhere", spending_less: "Spending less",
  ordering_less: "Ordering less often", smaller_orders: "Smaller orders",
};
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const dayText = (value) => {
  if (!value) return "";
  const [, month, day] = String(value).slice(0, 10).split("-").map(Number);
  return `${MONTHS[month - 1]} ${day}`;
};
const joinNames = (items) => (items.length <= 1 ? items[0] || "" : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`);

/** Why a customer is on the call list, as { title, detail } in plain words. */
export function whyText(row) {
  const title = REASON_TITLES[row.status] || row.status_label || "Needs a call";
  const reason = row.reasons?.find((item) => item.type === row.status) || row.reasons?.[0];
  if (row.status === "late") {
    const usual = cadence(row.typical_gap_days);
    const since = row.last_order_date ? `No order since ${dayText(row.last_order_date)} (${Number(row.days_since_last_order)} days).` : "No recent order.";
    return { title, detail: `${since}${usual ? ` Usually ${usual}.` : ""}` };
  }
  if (row.status === "switching") {
    const dropped = row.dropped_categories || [];
    const stopped = dropped.filter((item) => item.status === "stopped").map((item) => item.name);
    const cut = dropped.filter((item) => item.status !== "stopped").map((item) => item.name);
    const parts = [];
    if (stopped.length) parts.push(`Stopped ${joinNames(stopped)}.`);
    if (cut.length) parts.push(`Cut back ${joinNames(cut)}.`);
    const last = row.days_since_last_order != null ? `Last order ${daysAgo(row.days_since_last_order)}.` : "";
    return { title, detail: [last, ...(parts.length ? parts : [reason?.detail ? `${reason.detail}.` : ""])].filter(Boolean).join(" ") };
  }
  return { title, detail: reason?.detail ? `${reason.detail.replace(/\.$/, "")}.` : "" };
}
